export default __webpack_public_path__ + "static/media/logo_bullets.5de365e0.svg";